import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col-reverse items-center h-[66px]" }
const _hoisted_2 = ["src", "alt"]




export default /*@__PURE__*/_defineComponent({
  __name: 'ResultStack',
  props: {
    results: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.results, (res, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: __props.results.length - idx - 1,
        class: "mb-1 w-[70px] h-[7px]"
      }, [
        _createElementVNode("img", {
          src: 
          require(`@/assets/calculators/iczin/${
            res === 6 || res === 8 ? 'double_line' : 'single_line'
          }.png`)
        ,
          alt: res === 6 || res === 8 ? 'Двойная линия' : 'Одиночная линия',
          class: "block w-[70px] h-[7px]"
        }, null, 8, _hoisted_2)
      ]))
    }), 128))
  ]))
}
}

})